export const BYOB_DEFAULT_SIZE = 3; // Also in file saleBYOB
export const BYOB_DEFAULT_PERCENTAGE_OFF = 25; // Also in file saleBYOB
export const BYOB_URL_PARAM = "bundle_item";
export const BYOB_ATTR_KEY = "_bundle_hash";
export const BYOB_SIZE_KEY = "_bundle_size"; // Also in file saleBYOB
export const BYOB_PERCENTAGE_OFF_KEY = "_bundle_percent_off";
export const BYOB_SOURCE_PAGE = "_byob_source_page";
export const BYOB_CAN_HAVE_OPTIONAL_ITEM = "_can_have_optional_item";
